import { CSSProperties } from 'react';

import { AppColors } from '../../theme';

type EvidenceStyles = {
  evidence: CSSProperties;
  signature: CSSProperties;
  signature_img: CSSProperties;
  carousel_imgGrid: CSSProperties;
  carousel_img: CSSProperties;
  carousel_buttonSpace: CSSProperties;
  carousel_button: CSSProperties;
  evidence_link: CSSProperties;
};

const styles: EvidenceStyles = {
  evidence: {
    gap: '16px'
  },
  signature: {
    gap: '16px'
  },
  signature_img: {
    borderRadius: '4px',
    border: '1px',
    borderColor: AppColors.VA.NEUTRALS._30_
  },
  carousel_imgGrid: {
    gap: '10px',
    minWidth: 0,
    width: '100%',
    display: 'flex',
    paddingBottom: '30px',
    flexWrap: 'wrap'
  },
  carousel_img: {
    borderRadius: '4px'
  },
  carousel_buttonSpace: {
    backgroundColor: `${AppColors.VA.NEUTRALS._90_}BF`,
    padding: '8px',
    borderRadius: '4px'
  },
  carousel_button: {
    backgroundColor: 'transparent',
    color: AppColors.VA.NEUTRALS.WHITE
  },
  evidence_link: {
    color: AppColors.VA.PRIMARY._50_,
    textDecoration: 'underline'
  }
};

export default styles;
